<template>
  <AppTooltip v-if="isSubscriber && !isArchivingHidden" :disabled="disableTooltip">
    <template #activator="{ props }">
      <div v-bind="props" @click.prevent="handleClick">
        <slot :isArchivingEnabled="isArchivingEnabled"></slot>
      </div>
    </template>
    <span>{{ tooltipContent }}</span>
  </AppTooltip>
</template>

<script>
import { mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { ARCHIVES_ADD_ROUTE_NAME } from '@/router/routerData'
import { useArchivesStore } from '@/stores/archivesStore'

export default {
  name: 'ArchiveAddAccessBase',
  components: {
    AppTooltip,
  },
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  props: {
    disableTooltip: {
      type: Boolean,
      default: false,
    },
    routeOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('user', ['isSubscriber', 'isArchivingEnabled', 'isArchivingHidden']),
    tooltipContent () {
      return this.isArchivingEnabled
        ? this.$t('common.archives.ArchiveAddAccessBase.archiveTooltip')
        : this.$t('common.archives.ArchiveAddAccessBase.inactiveTooltip')
    },
  },
  methods: {
    handleClick () {
      if (!this.isArchivingEnabled) {
        this.archivesStore.setDiscoverElectronicSafeDialogIsOpen(true)
      } else {
        this.$router.push({
          name: ARCHIVES_ADD_ROUTE_NAME,
          ...this.routeOptions,
        })
      }
    },
  },
}
</script>
